// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XqI3","top":"styles_top__833zT","left":"styles_left__2G_RI","description":"styles_description__2gKMr"};